function validateMobileNumber(mobileNumber) {
  const phonePattern = /^[6-9][0-9]{9}$/;
  return phonePattern.test(mobileNumber);
}

function displayPhoneError(errorSelector, errorMessage, isSuccess = false) {
  const errorElement = document.querySelector(errorSelector);
  if (errorElement) {
    errorElement.textContent = errorMessage;
    errorElement.style.display = 'block';
    errorElement.style.color = isSuccess ? 'green' : 'red';
  }
}

function clearPhoneError(errorSelector) {
  const errorElement = document.querySelector(errorSelector);
  if (errorElement) {
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  }
}

async function handleDownloadLinkSubmit(event) {
  event.preventDefault();
  const mobileInput = document.querySelector('input[name="mobile_number"]');
  const mobileNumber = mobileInput.value.trim();
  const submitBtn = document.querySelector('#appDownloadLink .btn-gold');
  clearPhoneError('.phone-error');

  if (!mobileNumber) {
    displayPhoneError('.phone-error', 'Please enter a mobile number');
    return false;
  }

  if (!validateMobileNumber(mobileNumber)) {
    displayPhoneError(
      '.phone-error',
      'Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9'
    );
    return false;
  }

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';
  }

  let encrypted;
  try {
    encrypted = CryptoUtil.encryptRequest("POST", { mobileNumber });
  } catch (encryptError) {
    console.error('Encryption failed before request was sent:', encryptError.name, encryptError.message);
    displayPhoneError('.phone-error', 'Unable to secure the request in this browser. Please try over HTTPS.');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Download Link';
    }
    return false;
  }

  try {
    const headers = {
      "Content-Type": "application/json",
      "seal": encrypted.seal,
    };
    const body = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });

    console.log("bodybody",body);

    const url = `${window.Base_Url.Base_Url}/app-download/rajnigandha/send-link`;

    const response = await fetch(url, { method: "POST", mode: "cors", headers, body });

    if (!response.ok) {
      console.error('HTTP error:', response.status);
      displayPhoneError('.phone-error', 'Something went wrong. Please try again later.');
      return false;
    }

    const data = await response.json();
    const result = CryptoUtil.decryptResponse(data);

    if (result && result.success === true) {
      displayPhoneError('.phone-error', 'Download link sent successfully to your mobile number!', true);
      mobileInput.value = '';
    } else if (result && result.message) {
      displayPhoneError('.phone-error', result.message);
    } else {
      displayPhoneError('.phone-error', 'Failed to send download link. Please try again.');
    }
  } catch (error) {
    console.error('Request failed:', error.name, '-', error.message);
    if (error.message && error.message.includes('JSON')) {
      displayPhoneError('.phone-error', 'Server error occurred. Please try again later.');
    } else {
      displayPhoneError('.phone-error', 'Network error. Please check your connection and try again.');
    }
  } finally {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Download Link';
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#appDownloadLink');
  if (form) {
    form.addEventListener('submit', handleDownloadLinkSubmit);
  }
});
